import React from 'react';
import {Autocomplete, AutocompleteRenderInputParams, AutocompleteProps, TextField, createFilterOptions} from "@mui/material";
import {useAutocompleteOptions} from "../../../../hooks/autocomplete/useAutocompleteOptions";
import {AutocompleteOption} from "../../../SortFilter/interfaces";

interface FilterAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
  label: string;
  options: AutocompleteOption[];
}

// Defined outside component so reference is stable across renders — avoids MUI
// treating filterOptions as changed on every render and rebuilding the filtered list.
// Limit caps rendered items for performance with large option sets.
const filterOptions = createFilterOptions<AutocompleteOption>({
  matchFrom: 'any',
  stringify: (option) => option.label || '',
  limit: 100,
});

const FilterAutocomplete = (props: FilterAutocompleteProps) => {
  const { label, options, value, ...rest } = props;

  const renderInput = (params: AutocompleteRenderInputParams) => (
    <TextField {...params} label={label} variant={'standard'} />
  );

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
    resolvedValue,
  } = useAutocompleteOptions({ autocompleteOptions: options, value });

  return (
    <Autocomplete
      disablePortal
      disableClearable
      renderInput={renderInput}
      getOptionLabel={handleGetOptionLabel}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      renderOption={(optionProps, option) => (
        <li {...optionProps} key={option.id}>{option.label}</li>
      )}
      {...rest}
      options={options}
      filterOptions={filterOptions}
      value={resolvedValue}
    />
  );
};

export { FilterAutocomplete };
